import { Building2, GraduationCap } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useAuth } from '@/lib/auth'

export default function SelectTenantPage() {
  const { user } = useAuth()
  const navigate = useNavigate()

  // For now, redirect to the user's primary tenant
  // In the future, this could show a list of tenants the user belongs to
  if (user?.tenantSlug) {
    navigate(`/${user.tenantSlug}/dashboard`, { replace: true })
    return null
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50">
      <div className="mb-8 flex items-center space-x-2">
        <GraduationCap className="h-12 w-12 text-emerald-600" />
        <h1 className="text-3xl font-bold">テナント選択</h1>
      </div>
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>所属テナントを選択</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-center gap-4 py-8">
            <Building2 className="h-16 w-16 text-muted-foreground" />
            <p className="text-muted-foreground">所属するテナントが見つかりません。</p>
            <Button variant="outline" onClick={() => navigate('/login')}>
              ログインに戻る
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
